import { useSiteContext, useOrganizationId } from 'application/contexts/SiteContext';
import { usePageContext } from 'application/contexts/PageContext';
import { personToJsonLd, findTeamPersons, personIdSlug } from 'helpers/jsonLd';
import { JsonLdScript } from './JsonLdScript';

// One Person block per employeeList/contactPerson reference actually present on this page.
export const TeamJsonLd: React.FC = () => {
	const pageContext = usePageContext();
	const siteContext = useSiteContext();
	const organizationId = useOrganizationId();

	const persons = findTeamPersons(pageContext?.content?.pageSections);
	if (!persons.length) return null;

	const baseUrl = siteContext?.url?.replace(/\/$/, '');

	return (
		<>
			{persons.map((person) => {
				const data = personToJsonLd(person, organizationId);
				if (!data) return null;
				const id = baseUrl ? `${baseUrl}#person-${personIdSlug(person)}` : undefined;
				return (
					<JsonLdScript
						key={id || person.properties.fullName}
						id={`person-jsonld-${personIdSlug(person)}`}
						data={{ '@context': 'https://schema.org', '@id': id, ...data }}
					/>
				);
			})}
		</>
	);
};
